export const AIR_CREDIT_USAGE_TRACKING_ID_PREFIX = 'air-credit-usage';

export const AIRCreditUsageTrackingIds = {
  viewCallUsageCalculation: `${AIR_CREDIT_USAGE_TRACKING_ID_PREFIX}-view-calculation`,
  calculationModalClose: `${AIR_CREDIT_USAGE_TRACKING_ID_PREFIX}-calculation-modal-close`,
  toggleAccordion: `${AIR_CREDIT_USAGE_TRACKING_ID_PREFIX}-toggle-accordion`,
  showMoreLocations: `${AIR_CREDIT_USAGE_TRACKING_ID_PREFIX}-show-more-locations`,
  showLessLocations: `${AIR_CREDIT_USAGE_TRACKING_ID_PREFIX}-show-less-locations`,
  warningAlertCTA: `${AIR_CREDIT_USAGE_TRACKING_ID_PREFIX}-warning-alert-cta`,
  criticalAlertCTA: `${AIR_CREDIT_USAGE_TRACKING_ID_PREFIX}-critical-alert-cta`,
  exhaustedAlertCTA: `${AIR_CREDIT_USAGE_TRACKING_ID_PREFIX}-exhausted-alert-cta`,
  globalBannerCTA: `${AIR_CREDIT_USAGE_TRACKING_ID_PREFIX}-global-banner-cta`,
  globalBannerDismiss: `${AIR_CREDIT_USAGE_TRACKING_ID_PREFIX}-global-banner-dismiss`,
  globalWarningBannerCTA: `${AIR_CREDIT_USAGE_TRACKING_ID_PREFIX}-global-warning-banner-cta`,
  globalWarningBannerDismiss: `${AIR_CREDIT_USAGE_TRACKING_ID_PREFIX}-global-warning-banner-dismiss`,
  globalCriticalBannerCTA: `${AIR_CREDIT_USAGE_TRACKING_ID_PREFIX}-global-critical-banner-cta`,
  globalCriticalBannerDismiss: `${AIR_CREDIT_USAGE_TRACKING_ID_PREFIX}-global-critical-banner-dismiss`,
};

export const getAIRCreditUsageTrackingId = (action: string) => `${AIR_CREDIT_USAGE_TRACKING_ID_PREFIX}-${action}`;

export const AIRSubscriptionTrackingIds = {
  manageSubscriptionBtn: 'air-subscription-manage-subscription-button',
  callToDowngradeBtn: 'air-subscription-call-to-downgrade-button',
};

export const AIRManageSubscriptionModalTrackingIds = {
  selectLocationNextBtn: 'air-manage-subscription-modal-select-location-next-button',
  selectLocationCancelBtn: 'air-manage-subscription-modal-select-location-cancel-button',
  selectSubscriptionNextBtn: 'air-manage-subscription-modal-select-subscription-next-button',
  selectSubscriptionBackBtn: 'air-manage-subscription-modal-select-subscription-back-button',
  selectSubscriptionCancelBtn: 'air-manage-subscription-modal-select-subscription-cancel-button',
  confirmBackBtn: 'air-manage-subscription-modal-confirm-back-button',
  confirmCancelBtn: 'air-manage-subscription-modal-confirm-cancel-button',
  confirmProceedBtn: 'air-manage-subscription-modal-confirm-proceed-button',
  closeModalBtn: 'air-manage-subscription-modal-close-button',
  increaseQuotaBtn: 'air-manage-subscription-modal-increase-quota-button',
  decreaseQuotaBtn: 'air-manage-subscription-modal-decrease-quota-button',
  confirmTermsLink: 'air-manage-subscription-modal-confirm-terms-link',
  confirmTermsCheckbox: 'air-manage-subscription-modal-confirm-terms-checkbox',
};
